var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.36707 11.2911H20.3671C20.566 11.2911 20.7567 11.3701 20.8974 11.5107C21.038 11.6514 21.1171 11.8422 21.1171 12.0411C21.1171 12.24 21.038 12.4308 20.8974 12.5714C20.7567 12.7121 20.566 12.7911 20.3671 12.7911H5.36707C5.16815 12.7911 4.97739 12.7121 4.83674 12.5714C4.69608 12.4308 4.61707 12.24 4.61707 12.0411C4.61707 11.8422 4.69608 11.6514 4.83674 11.5107C4.97739 11.3701 5.16815 11.2911 5.36707 11.2911Z",
    fill: "#785607"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67744 12.041L11.8979 18.26C12.0388 18.4009 12.1179 18.5919 12.1179 18.791C12.1179 18.9902 12.0388 19.1812 11.8979 19.322C11.7571 19.4629 11.5661 19.542 11.3669 19.542C11.1678 19.542 10.9768 19.4629 10.8359 19.322L4.08594 12.572C4.0161 12.5024 3.96068 12.4196 3.92287 12.3285C3.88506 12.2374 3.8656 12.1397 3.8656 12.041C3.8656 11.9424 3.88506 11.8447 3.92287 11.7536C3.96068 11.6625 4.0161 11.5797 4.08594 11.51L10.8359 4.76005C10.9768 4.61922 11.1678 4.5401 11.3669 4.5401C11.5661 4.5401 11.7571 4.61922 11.8979 4.76005C12.0388 4.90088 12.1179 5.09188 12.1179 5.29105C12.1179 5.49021 12.0388 5.68122 11.8979 5.82205L5.67744 12.041Z",
    fill: "#785607"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.398ca0587966bc86cc027d74750c29a5.svg";
export { ForwardRef as ReactComponent };